import getters from "@/store/modules/contact/getters";
export default {
    namespaced: true,
    state() {
        return {
            phone: "(+212) 7 07 00 84 87",
            email: "imadchai2@gmail.com",
            github: "https://github.com/Im-Mad",
            gmail: "https://mail.google.com/mail/u/0/?fs=1&tf=cm&to=imadchai2@gmail.com",
            linkedin: "https://www.linkedin.com/in/imad-chaichaa-a30786201/",
            twitter: "#",
        }
    },
    getters,
}